import DataService from "./data-service";

export default class extends DataService {
    static Service = DataService.TYPE.REGLEMENTS;
}
